import { Form, Input } from 'antd';
import EyeIcon from 'assets/icons/eye.svg';
//eyeSlash
import EyeSlashIcon from 'assets/icons/eye-slash.svg';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

interface props {
    onChange?: () => void;
}
export const PasswordFormItem = ({
    onChange = () => {
        /** */
    },
}: props) => {
    return (
        <section style={{ width: '100%', marginTop: 16 }}>
            <div style={{ marginBottom: 16 }} className="label">
                パスワードを入力してください。
            </div>
            <Form.Item
                required={false}
                className=" label-form-style "
                name="password"
                label={false}
                rules={[
                    {
                        required: true,
                        message: getMessage('In_Required', 'パスワード'),
                    },
                    {
                        min: 8,
                        message: getMessage('Pass_Invalid_2'),
                    },
                ]}
            >
                <Input.Password
                    iconRender={(visible) =>
                        visible ? (
                            <img className="button-style" alt="" src={EyeIcon} />
                        ) : (
                            <img className="button-style" alt="" src={EyeSlashIcon} />
                        )
                    }
                    size="large"
                    minLength={8}
                    style={{ width: '100%' }}
                    placeholder={PLACEHOLDER.PASSWORD}
                    onChange={onChange}
                />
            </Form.Item>
        </section>
    );
};
